import styled from "styled-components";

export const StyledSessionDetailsDrawerBookingDetailsHeader = styled.p`
  font-weight: 600;
  font-size: 1.6rem;
`;
export const StyledSessionDetailsDrawerBookingQuestionsItem = styled.div`
  font-size: 1.4rem;
  color: #1c1726;

  .bold-text {
    font-weight: 600;
  }
`;
